/*
 * UserProfile Messages
 *
 * This contains all the text for the UserProfile component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  header: {
    id: 'app.containers.UserProfile.header',
    defaultMessage: 'User Profile',
  },
  editUserProfileFailure: {
    id: 'app.containers.UserProfile.editUserProfileFailure',
    defaultMessage: 'Error while saving the profile, please try again.',
  },
  editUserProfileSuccess: {
    id: 'app.containers.UserProfile.editUserProfileSuccess',
    defaultMessage: 'Profile successfully saved.',
  },
  saveButton: {
    id: 'app.containers.UserProfile.saveButton',
    defaultMessage: 'Save Profile',
  },
  brother: {
    id: 'app.containers.UserProfile.brother',
    defaultMessage: 'Brother',
  },
  sister: {
    id: 'app.containers.UserProfile.sister',
    defaultMessage: 'Sister',
  },
  pioneer: {
    id: 'app.containers.UserProfile.pioneer',
    defaultMessage: 'Pioneer',
  },
  elder: {
    id: 'app.containers.UserProfile.elder',
    defaultMessage: 'Elder',
  },
  ministerialServant: {
    id: 'app.containers.UserProfile.ministerialServant',
    defaultMessage: 'Ministerial Servant',
  },
  servicePartner: {
    id: 'app.containers.UserProfile.servicePartner',
    defaultMessage:
      'If possible, you will get assignments together with {partnerName}',
  },
  noServicePartner: {
    id: 'app.containers.UserProfile.noServicePartner',
    defaultMessage:
      'Currently there is no brother with whom you always want to be assigned.',
  },
  telephoneLabel: {
    id: 'app.containers.UserProfile.telephoneLabel',
    defaultMessage: 'Telephone Number',
  },
  emailLabel: {
    id: 'app.containers.UserProfile.emailLabel',
    defaultMessage: 'Email address',
  },
  changeMail: {
    id: 'app.containers.UserProfile.changeMail',
    defaultMessage: 'Change',
  },
  settings: {
    id: 'app.containers.UserProfile.settings',
    defaultMessage: 'Settings',
  },
  deleteNotAssignedApplicationsLabel: {
    id: 'app.containers.UserProfile.deleteNotAssignedApplicationsLabel',
    defaultMessage: 'Delete not assigned applications',
  },
  deleteNotAssignedApplicationsDescription: {
    id: 'app.containers.UserProfile.deleteNotAssignedApplicationsDescription',
    defaultMessage:
      "Please don't tick the checkbox if you want to stay applied as substitute, even though you have not been assigned initially.",
  },
  analyticsConsentHeading: {
    id: 'app.containers.UserProfile.analyticsConsentHeading',
    defaultMessage: 'Analytics consent',
  },
  analyticsConsentLabel: {
    id: 'app.containers.UserProfile.analyticsConsentLabel',
    defaultMessage: 'I want to help improving this software',
  },
  analyticsConsentDescription: {
    id: 'app.containers.UserProfile.analyticsConsentDescription',
    defaultMessage:
      'When enabled, anonymous usage data and error reports are sent to help us improve the application. You can change this at any time.',
  },
  analyticsConsentNotYetDecided: {
    id: 'app.containers.UserProfile.analyticsConsentNotYetDecided',
    defaultMessage:
      'You have not yet responded to the analytics consent banner.',
  },
  doNotSuggestRecurrentApplications: {
    id: 'app.containers.UserProfile.doNotSuggestRecurrentApplications',
    defaultMessage: 'I do not want suggestions for automatic applications',
  },
  doNotSuggestRecurrentApplicationsDescription: {
    id: 'app.containers.UserProfile.doNotSuggestRecurrentApplicationsDescription',
    defaultMessage:
      'If you apply repeatedly on the same shifts, you will get an offer, to apply you automatically. If you tick the checkbox, you will no longer get such suggestions.',
  },
  languageLabel: {
    id: 'app.containers.UserProfile.languageLabel',
    defaultMessage: 'Interface Language',
  },
  languageEnglish: {
    id: 'app.containers.UserProfile.languageEnglish',
    defaultMessage: 'English',
  },
  languageGerman: {
    id: 'app.containers.UserProfile.languageGerman',
    defaultMessage: 'German',
  },
  languageFrench: {
    id: 'app.containers.UserProfile.languageFrench',
    defaultMessage: 'French',
  },
  languageRussian: {
    id: 'app.containers.UserProfile.languageRussian',
    defaultMessage: 'Russian',
  },
  languageSpanish: {
    id: 'app.containers.UserProfile.languageSpanish',
    defaultMessage: 'Spanish',
  },
  languages: {
    id: 'app.containers.UserProfile.languages',
    defaultMessage: 'Languages you speak',
  },
  invalidPhoneNumber: {
    id: 'app.containers.UserProfile.invalidPhoneNumber',
    defaultMessage: 'Invalid telephone number',
  },
  saveSettings: {
    id: 'app.containers.UserProfile.saveSettings',
    defaultMessage: 'Save settings',
  },
  saveProfileData: {
    id: 'app.containers.UserProfile.saveProfileData',
    defaultMessage: 'Save profile data',
  },
  back: {
    id: 'app.containers.UserProfile.back',
    defaultMessage: 'Back',
  },
  backToMenu: {
    id: 'app.containers.UserProfile.backToMenu',
    defaultMessage: 'Back to menu',
  },
  account: {
    id: 'app.containers.UserProfile.account',
    defaultMessage: 'Account',
  },
  routePreferences: {
    id: 'app.containers.UserProfile.routePreferences',
    defaultMessage: 'Route preferences',
  },
  calendarSubscription: {
    id: 'app.containers.UserProfile.calendarSubscription',
    defaultMessage: 'Calendar subscription',
  },
});
